import { render, staticRenderFns } from "./SimpleExpr.vue?vue&type=template&id=1efc8d50&scoped=true&"
import script from "./SimpleExpr.vue?vue&type=script&lang=ts&"
export * from "./SimpleExpr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc8d50",
  null
  
)

export default component.exports